import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { getBrandAppService } from "../../../services/BrandAppServices";
import { getPackageOffer } from "../../../services/PaymentOfferManagement/PackageOfferManagement";
import AdminMenu from "../../AdminMenu";

const PackageOfferManagement = () => {
  const navigate = useNavigate();
  const [offersData, setOffersData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [loading, setLoading] = useState(false);

  const [appServiceList, setAppServiceList] = useState([]);

  const fetchOfferManagementData = async () => {
    setLoading(true);
    try {
      // Fetch and format app services
      const appServiceResponse = await getBrandAppService(brandId);
      if (!appServiceResponse.data.error) {
        const appServices = appServiceResponse.data;
        const formattedServices = appServices.map((service) => ({
          id: service.appService.id,
          name: service.appService.name,
        }));
        setAppServiceList(formattedServices);

        // Create a map from ID to name for quick lookup
        const idToNameMap = formattedServices.reduce((acc, service) => {
          acc[service.id] = service.name;
          return acc;
        }, {});

        // Fetch offers
        const response = await getPackageOffer(brandId);
        if (!response.data.error) {
          const offers = response.data;

          // Replace itemList IDs with names
          const updatedOffers = offers.map((offer) => ({
            ...offer,
            itemList: offer.itemList.map((id) => idToNameMap[id] || id), // fallback to ID if name not found
          }));

          setOffersData(updatedOffers);
          setLoading(false);
        }
      }
    } catch (err) {
      console.error("Error:", err);
      setLoading(false); // Ensure loading state is reset in case of an error
    }
  };

  useEffect(() => {
    fetchOfferManagementData();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{item?.name}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Offer Category :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.offerCategory?.name}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Validity :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.validity}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/PackageOfferCreate", {
                        state: {
                          id: item.id,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Status:
                  </p>

                  {item.status === "ACTIVE" ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize">Active </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <p className="text-lg font-medium capitalize">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 1,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Valid From :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formatDate(item.validFrom)} - {formatDate(item.validTo)}
                  </p>
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 1,
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Value :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.value}</p>
                </div>
              </div>

              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Service Value :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.serviceValue}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Package Value :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.packageValue}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                     
                  </p>
                  <p className="text-lg font-medium capitalize">
                     
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Subscription Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between mx-4">
          <div className="py-1">
            <p className=" text-2xl  font-bold ">CREATE OFFERS</p>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
            onClick={() => {
              navigate("/PackageOfferCreate", {
                state: {
                  id: null,
                },
              });
            }}
          >
            <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : offersData?.length > 0 ? (
          <div>
            <div>{renderCardItem(offersData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">
              No Store Subscription Management Found
            </p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PackageOfferManagement;
